import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

// Retorna os cadastros individuais
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_cpf - CPF do profissional
 */
export async function getCadastros(cod_ibge, nu_cpf) {
  try {
    const { data } = await Vue.prototype.$api.post('/app/acompanhamento', {
      co_ibge: cod_ibge,
      cpf: nu_cpf,
    })
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/acompanhamento/${cod_ibge}/equipe/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}
export async function getCadastrosPorMicroArea(cod_ibge, nu_ine, micro_area) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/acompanhamento/${cod_ibge}/equipe/${nu_ine}/microarea/${micro_area}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}
// Buscar última atualização dos dados
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getUltimaAtualizacao(cod_ibge) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/ultima-atualizacao-dos-dados/' + cod_ibge
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Buscar data da fonte eSUS PEC
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getFonteEsusPec(cod_ibge) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/cadastros-individuais/fonte-esus-pec/' + cod_ibge
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna o nome da cor de acordo com o valor
/**
 *
 * @param {int} valor - Valor numérico
 */
export function getCorTextoResultado(valor) {
  if (valor >= 60) {
    return 'green-color'
  } else {
    return 'red-color'
  }
}

// Retorna o nome da cor para pintar a linha da tabela
/**
 *
 */
export function printTableRow(item) {
  if (item.is_acompanhado == null || item.is_acompanhado == '0') {
    return 'red'
  } else {
    return 'green'
  }
}

export function generatePdf(
  cadastros,
  selectEquipe,
  micro_area,
  data_secretaria_de_saude
) {
  let title_pdf = 'Acompanhamento'
  let titlePdfSave = utils.methods.titlePdf('Acompanhamento')

  let description_pdf =
    'Pessoas atendidas ou acompanhadas por eSF, eAP, eSB e eMulti.'
  let headers_pdf = ['NOME', 'NASCIMENTO', 'MÃE', 'CI', 'ACOMPANHAMENTO']
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.no_mae = cadastros[i].no_mae
    obj.cadastro =
      cadastros[i].dt_ultima_ficha != null
        ? `${utils.methods.formatDate(cadastros[i].dt_ultima_ficha)}\n(${
            cadastros[i].percent_fci_completa
          }%)`
        : ''
    if (cadastros[i].ultimo_acompanhamento == null) {
      obj.acompanhamento = 'Sem atendimento'
    } else {
      let ultimoAcompanhamento = JSON.parse(cadastros[i].ultimo_acompanhamento)
      obj.acompanhamento =
        ultimoAcompanhamento.dt_atendimento != undefined
          ? utils.methods.formatDate(ultimoAcompanhamento.dt_atendimento) +
            ` (${ultimoAcompanhamento.tipo})`
          : ''
    }
    obj.is_acompanhado = cadastros[i].is_acompanhado
    data_pdf.push(obj)
  }

  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Microárea',
            value: micro_area,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let is_acompanhado = data.row.raw[5]
          if (is_acompanhado == null || is_acompanhado == '0') {
            doc.setTextColor(194, 10, 16) // vermelho
          } else {
            doc.setTextColor(2, 99, 57) // verde
          }

          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export function resultadoDoMunicipio(
  indicadorResultado,
  dadosDaTabelaResultado
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0

  let dadosDoMunicipio = undefined
  if (indicadorResultado !== null) {
    dadosDoMunicipio = dadosDaTabelaResultado.find((item) => {
      return item.ibge_ine === 'MUN' && item.indicador == '30'
    })
  } else {
    dadosDoMunicipio = dadosDaTabelaResultado.find((item) => {
      return item.ibge_ine === 'MUN' && item.indicador == '30'
    })
  }

  if (dadosDoMunicipio === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
    }
  }

  numerador = dadosDoMunicipio.numerador
  denominador = dadosDoMunicipio.denominador
  resultado = dadosDoMunicipio.resultado

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
  }
}

export function resultadoClassificacaoMunicipio(
  indicadorResultado,
  tabelaResultado
) {
  let resultado = 0
  let escore = 0
  let classificacao = '-'
  let dadosFormula = ''

  let dadosDoMunicipio = tabelaResultado.find((item) => {
    return (
      item.ibge_ine === 'MUN' && item.indicador == indicadorResultado.indicador
    )
  })
  if (dadosDoMunicipio === undefined) {
    return {
      resultado: 0,
      escore: 0,
      classificacao: '-',
      dadosFormula: '',
    }
  }

  if (indicadorResultado !== null) {
    let dados = JSON.parse(dadosDoMunicipio.dados)
    if (
      indicadorResultado.value == 'acompanhamento-por-cadastro-esus' &&
      dados.nivel == 1
    ) {
      resultado = dados.result_cad_pec
      escore = dados.escore_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'acompanhamento-por-cadastro-esus',
        parametro: dados.cad_pec,
        qtd_acomp1_0: dados.qtd_acomp1_0,
        qtd_acomp1_2: dados.qtd_acomp1_2,
        qtd_acomp1_3: dados.qtd_acomp1_3,
        qtd_acomp2_5: dados.qtd_acomp2_5,
      }
    }

    if (
      indicadorResultado.value == 'vinculo-acompanhamento-por-cadastro-esus' &&
      dados.nivel == 1
    ) {
      resultado = dados.result_cad_pec
      escore = dados.escore_vinc_acomp_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'vinculo-acompanhamento-por-cadastro-esus',
        escore_x: dados.escore_pec_cad,
        escore_y: dados.escore_pec_acomp,
        resultado: dados.escore_vinc_acomp_pec,
      }
    }
  }
  return {
    resultado: resultado,
    escore: escore,
    classificacao: classificacao,
    dados: dadosFormula,
  }
}

export function resultadoDaEquipe(
  indicadorResultado,
  dadosDaTabelaResultado,
  nuIne
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0

  let dadosDoMunicipio = undefined
  if (indicadorResultado !== null) {
    dadosDoMunicipio = dadosDaTabelaResultado.find((item) => {
      return item.ibge_ine === nuIne && item.indicador == '30'
    })
  } else {
    dadosDoMunicipio = dadosDaTabelaResultado.find((item) => {
      return item.ibge_ine === nuIne && item.indicador == '30'
    })
  }

  if (dadosDoMunicipio === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
    }
  }

  numerador = dadosDoMunicipio.numerador
  denominador = dadosDoMunicipio.denominador
  resultado = dadosDoMunicipio.resultado

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
  }
}

export function resultadoClassificacaoEquipe(
  indicadorResultado,
  tabelaResultado,
  nu_ine
) {
  let resultado = 0
  let escore = 0
  let classificacao = '-'
  let dadosFormula = ''

  let dadosDaEquipe = tabelaResultado.find((item) => {
    return (
      item.ibge_ine === nu_ine && item.indicador == indicadorResultado.indicador
    )
  })
  if (dadosDaEquipe === undefined) {
    return {
      resultado: 0,
      escore: 0,
      classificacao: '-',
      dadosFormula: '',
    }
  }
  if (indicadorResultado !== null) {
    let dados = JSON.parse(dadosDaEquipe.dados)
    console.log('dados', dados)
    if (
      indicadorResultado.value == 'acompanhamento-por-cadastro-esus' &&
      dados.nivel == 2
    ) {
      resultado = dados.result_cad_pec
      escore = dados.escore_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'acompanhamento-por-cadastro-esus',
        parametro: dados.cad_pec,
        qtd_acomp1_0: dados.qtd_acomp1_0,
        qtd_acomp1_2: dados.qtd_acomp1_2,
        qtd_acomp1_3: dados.qtd_acomp1_3,
        qtd_acomp2_5: dados.qtd_acomp2_5,
      }
    }
    if (
      indicadorResultado.value == 'acompanhamento-por-parametro-de-cadastro' &&
      dados.nivel == 2
    ) {
      resultado = dados.result_param_cad
      escore = dados.escore_param
      classificacao = dados.classificacao_param
      dadosFormula = {
        tipo: 'acompanhamento-por-parametro-de-cadastro',
        parametro: dados.cad_param,
        qtd_acomp1_0: dados.qtd_acomp1_0,
        qtd_acomp1_2: dados.qtd_acomp1_2,
        qtd_acomp1_3: dados.qtd_acomp1_3,
        qtd_acomp2_5: dados.qtd_acomp2_5,
      }
    }
    if (
      indicadorResultado.value == 'vinculo-acompanhamento-por-cadastro-esus' &&
      dados.nivel == 2
    ) {
      resultado = dados.result_cad_pec
      escore = dados.escore_vinc_acomp_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'vinculo-acompanhamento-por-cadastro-esus',
        escore_x: dados.escore_pec_cad,
        escore_y: dados.escore_pec_acomp,
        resultado: dados.escore_vinc_acomp_pec,
      }
    }
    if (
      indicadorResultado.value ==
        'vinculo-acompanhamento-por-parametro-de-cadastro' &&
      dados.nivel == 2
    ) {
      resultado = dados.result_cad_pec
      escore = dados.escore_vinc_acomp_param
      classificacao = dados.classificacao_param
      dadosFormula = {
        tipo: 'vinculo-acompanhamento-por-cadastro-esus',
        escore_x: dados.escore_param_cad,
        escore_y: dados.escore_param_acomp,
        resultado: dados.escore_vinc_acomp_pec,
      }
    }
  }

  return {
    resultado: resultado,
    escore: escore,
    classificacao: classificacao,
    dados: dadosFormula,
  }
}

export function resultadoDaMicroArea(
  indicadorResultado,
  dadosDaTabelaResultado,
  micro_area
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0

  let dadosDoMunicipio = undefined
  if (indicadorResultado !== null) {
    dadosDoMunicipio = dadosDaTabelaResultado.find((item) => {
      return item.ibge_ine === micro_area && item.indicador == '30'
    })
  } else {
    dadosDoMunicipio = dadosDaTabelaResultado.find((item) => {
      return item.ibge_ine === micro_area && item.indicador == '30'
    })
  }

  if (dadosDoMunicipio === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
    }
  }

  numerador = dadosDoMunicipio.numerador
  denominador = dadosDoMunicipio.denominador
  resultado = dadosDoMunicipio.resultado

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
  }
}

export function resultadoClassificacaoMicroArea(
  indicadorResultado,
  tabelaResultado,
  micro_area
) {
  let resultado = 0
  let escore = 0
  let classificacao = '-'
  let dadosFormula = ''

  let dadosDaMicroArea = tabelaResultado.find((item) => {
    return (
      item.ibge_ine === micro_area &&
      item.indicador == indicadorResultado.indicador
    )
  })
  if (dadosDaMicroArea === undefined) {
    return {
      resultado: 0,
      escore: 0,
      classificacao: '-',
      dadosFormula: '',
    }
  }

  if (indicadorResultado !== null) {
    let dados = JSON.parse(dadosDaMicroArea.dados)
    if (
      indicadorResultado.value == 'acompanhamento-por-cadastro-esus' &&
      dados.nivel == 3
    ) {
      resultado = dados.result_cad_pec
      escore = dados.escore_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'acompanhamento-por-cadastro-esus',
        parametro: dados.cad_pec,
        qtd_acomp1_0: dados.qtd_acomp1_0,
        qtd_acomp1_2: dados.qtd_acomp1_2,
        qtd_acomp1_3: dados.qtd_acomp1_3,
        qtd_acomp2_5: dados.qtd_acomp2_5,
      }
    }
    if (
      indicadorResultado.value == 'vinculo-acompanhamento-por-cadastro-esus' &&
      dados.nivel == 3
    ) {
      resultado = dados.result_cad_pec
      escore = dados.escore_vinc_acomp_pec
      classificacao = dados.classificacao_pec
      dadosFormula = {
        tipo: 'vinculo-acompanhamento-por-cadastro-esus',
        escore_x: dados.escore_pec_cad,
        escore_y: dados.escore_pec_acomp,
        resultado: dados.escore_vinc_acomp_pec,
      }
    }
  }

  return {
    resultado: resultado,
    escore: escore,
    classificacao: classificacao,
    dados: dadosFormula,
  }
}

export function serieHistoricaMunicipio(dadosSerieHistorica, indicador) {
  let dataItens = dadosSerieHistorica
  if (indicador !== null) {
    dataItens = dataItens.filter((item) => {
      return item.indicador == indicador.value && item.ibge_ine === 'MUN'
    })
  }
  let dataItens12meses = dataItens.slice(Math.max(dataItens.length - 12, 0))
  let array_chart_municipio = []
  let array_xaxis = []
  //carregar eixo x
  for (let i = 0; i < dataItens12meses.length; i++) {
    array_xaxis.push(dataItens12meses[i].mes_ano)
  }
  // carregar dados do município
  for (let i = 0; i < dataItens12meses.length; i++) {
    array_chart_municipio.push(dataItens12meses[i].resultado)
  }
  return {
    array_xaxis: array_xaxis,
    array_chart_municipio: array_chart_municipio,
    data_dados_chart:
      dataItens12meses.length > 0
        ? utils.methods.formatDate(dataItens12meses[0].data_dados)
        : '',
  }
}

export function serieHistoricaEquipe(
  xaxis,
  dadosSerieHistorica,
  indicadorGrafico,
  nu_ine
) {
  let array_chart_equipe = []
  for (let i = 0; i < xaxis.length; i++) {
    var eixo_x_atual = xaxis[i]
    let dataItens = dadosSerieHistorica
    if (indicadorGrafico !== null) {
      dataItens = dataItens.filter((item) => {
        return (
          item.indicador == indicadorGrafico.value && item.ibge_ine == nu_ine
        )
      })
    }
    let dataItens12meses = dataItens.slice(Math.max(dataItens.length - 12, 0))
    for (const item of dataItens12meses) {
      var resultado = 0
      if (item.mes_ano == eixo_x_atual) {
        resultado = item.resultado
        break
      } else {
        resultado = null
      }
    }
    array_chart_equipe.push(resultado)
  }

  return {
    array_chart_equipe: array_chart_equipe,
  }
}

export function serieHistoricaMicroArea(
  xaxis,
  dadosSerieHistorica,
  indicadorGrafico,
  micro_area
) {
  let array_chart_micro_area = []
  for (let i = 0; i < xaxis.length; i++) {
    var eixo_x_atual = xaxis[i]
    let dataItens = dadosSerieHistorica
    if (indicadorGrafico !== null) {
      dataItens = dataItens.filter((item) => {
        return (
          item.indicador == indicadorGrafico.value &&
          item.ibge_ine == micro_area
        )
      })
    }
    let dataItens12meses = dataItens.slice(Math.max(dataItens.length - 12, 0))
    for (const item of dataItens12meses) {
      var resultado = 0
      if (item.mes_ano == eixo_x_atual) {
        resultado = item.resultado
        break
      } else {
        resultado = null
      }
    }
    array_chart_micro_area.push(resultado)
  }

  return {
    array_chart_micro_area: array_chart_micro_area,
  }
}
